import React from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import {
  SaveAs,
  Save,
  ThumbUp,
  ThumbDown,
  Cancel,
  ExitToApp,
  LinkOff,
  Link,
} from "@mui/icons-material";

const C1FormButtons = ({ props, onSubmit }) => {
  const navigate = useNavigate();

  let save = null;
  if (props.showSave) {
    save = (
      <Tooltip title="Save">
        <IconButton
          aria-label="save"
          type="submit"
          color="primary"
          onClick={() => onSubmit?.("save")}
        >
          <SaveAs />
        </IconButton>
      </Tooltip>
    );
  }

  let submit = null;
  if (props.showSubmit) {
    submit = (
      <Tooltip title="Submit">
        <IconButton
          aria-label="submit"
          type="submit"
          color="primary"
          onClick={() => onSubmit?.("submit")}
        >
          <Save />
        </IconButton>
      </Tooltip>
    );
  }

  let cancel = null;
  if (props.showCancel) {
    cancel = (
      <Tooltip title="Cancel">
        <IconButton
          aria-label="cancel"
          type="button"
          onClick={() => navigate(-1)}
          color="secondary"
        >
          <Cancel />
        </IconButton>
      </Tooltip>
    );
  }

  let back = null;
  if (props.showBack) {
    back = (
      <Tooltip title="Exit">
        <IconButton
          aria-label="exit"
          type="button"
          onClick={() => navigate(-1)}
          color="secondary"
        >
          <ExitToApp />
        </IconButton>
      </Tooltip>
    );
  }

  let approve = null;
  if (props.showApprove) {
    approve = (
      <Tooltip title="Generate">
        <IconButton aria-label="approve" type="submit" color="primary">
          <ThumbUp />
        </IconButton>
      </Tooltip>
    );
  }

  let reject = null;
  if (props.showReject) {
    reject = (
      <Tooltip title="Reject">
        <IconButton aria-label="reject" type="submit" color="primary">
          <ThumbDown />
        </IconButton>
      </Tooltip>
    );
  }

  let activate = null;
  if (props.showActivate) {
    activate = (
      <Tooltip title="Activate">
        <IconButton aria-label="activate" type="submit" color="primary">
          <Link />
        </IconButton>
      </Tooltip>
    );
  }

  let deactivate = null;
  if (props.showDeactivate) {
    deactivate = (
      <Tooltip title="Deactivate">
        <IconButton aria-label="deactivate" type="submit" color="primary">
          <LinkOff />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Grid container alignItems="center" justifyContent="flex-end">
      <div>
        {save}
        {submit}
        {approve}
        {reject}
        {activate}
        {deactivate}
        {cancel}
        {back}
      </div>
    </Grid>
  );
};

export default C1FormButtons;
